<template>
	<wt-selector :options="options" :disabled="disabled" v-model="Value" :clearable="true" :filterable="filterable"></wt-selector>
</template>
<script>
export default {
  name: 'lab-product-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
		filterable:{
			type:Boolean,
			default:false
		}
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      this.$store.dispatch('getAllExamBasis').then(data => {
        this.options = data.filter(e=>e).map(e=>{
          return {
            label: e,
            value: e
          }
        })
      }).catch((err)=>{
        this.$message.error(err || err.message)
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
